import { Component, OnInit, OnDestroy, AfterViewInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';

@Component({
    selector: 'topo-infinite-scroller',
    templateUrl: './infinite-scroller.component.html',
    styleUrls: ['./infinite-scroller.component.scss'],
    standalone: false
})
export class InfiniteScrollerComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() options = {};
  @Input() style: any;
  @Output() scrolled = new EventEmitter();
  @ViewChild('anchor') anchor: ElementRef<HTMLElement>;
  @ViewChild('anchor') root: ElementRef<HTMLElement>;

  private observer: IntersectionObserver;

  get element() {
    return this.root.nativeElement;
  }

  constructor(private host: ElementRef) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const options = {
      root: this.isRootScrollable() ? this.root.nativeElement : null,
      ...this.options,
    };

    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.scrolled.emit();
      }
    }, options);

    this.observer.observe(this.anchor.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }

  isRootScrollable(): boolean {
    const style = window.getComputedStyle(this.element);
    const isScrollable = style.getPropertyValue('overflow').includes('auto') || style.getPropertyValue('overflow-y') === 'scroll';
    return isScrollable;
  }
}
